import { useState } from "react"
import PropTypes from "prop-types"
import { Alert } from "@mui/material"
import { DataGridPremium as DataGrid, GridColumnMenu, useGridApiRef } from "@mui/x-data-grid-premium"
import { ErrorBoundary } from "@sentry/react"
import { MAX_PIVOT_COLUMNS } from "helpers/ai"
import FullSizeArtifactDialog from "../../full-size-artifact-dialog"
import ExplainSteps from "./explain-steps"

export default function FullSizeTable({ open, onClose, columns, rows, explainSteps }) {
  const apiRef = useGridApiRef()
  const [pivotWarning, setPivotWarning] = useState(null)

  const CustomColumnMenu = (props) => {
    return (
      <GridColumnMenu
        {...props}
        slots={{
          columnMenuAggregationItem: null,
          columnMenuGroupingItem: null,
        }}
      />
    )
  }

  const handlePivotModelChange = (model) => {
    const pivotColumns = model?.columns || []
    if (pivotColumns.length > MAX_PIVOT_COLUMNS) {
      setPivotWarning(`Too many pivot columns selected. Maximum allowed is ${MAX_PIVOT_COLUMNS}.`)
      // Reset to previous state
      apiRef.current.setPivotModel({
        ...model,
        columns: pivotColumns.slice(0, MAX_PIVOT_COLUMNS),
      })
    } else {
      setPivotWarning(null)
    }
  }

  return <FullSizeArtifactDialog
    open={open}
    onClose={onClose}
    title="Generated Table"
  >
    {explainSteps && <ExplainSteps explainSteps={explainSteps} />}
    {pivotWarning && (
      <Alert severity="warning" className="pivot-warning">
        {pivotWarning}
      </Alert>
    )}
    <ErrorBoundary fallback={<div className="grid-error-boundary">⚠️ Failed to load the grid.</div>}>
      <DataGrid
        className="table-artifact-full-screen-data-grid"
        apiRef={apiRef}
        density="compact"
        rows={rows}
        columns={columns}
        onPivotModelChange={handlePivotModelChange}
        slots={{
          columnMenu: CustomColumnMenu,
        }}
        showToolbar
        pagination
      />
    </ErrorBoundary>
  </FullSizeArtifactDialog>
}

FullSizeTable.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  explainSteps: PropTypes.string,
}
